import { useEffect, useState } from 'react'
import { apolloSdk } from 'src/graphql/apolloSdk'
import { useUserInfoLazyQuery } from 'src/graphql/generated/hooks'
import { IPublicationState } from 'src/graphql/generated/requests'
import { useAuthenticated } from 'src/hooks/useAuthenticated'

export const useAdminEmailCheck = () => {
  const { session, status } = useAuthenticated()
  const [loadUserInfo, { loading, data: userInfoData }] = useUserInfoLazyQuery()
  const [isAdmin, setIsAdmin] = useState(false)
  const [isCheckingAdmin, setIsCheckingAdmin] = useState(true)

  useEffect(() => {
    const checkAdminEmail = async () => {
      const userEmail = userInfoData?.userInfo?.email
      if (userEmail) {
        const present = await apolloSdk.emailReceivers({
          filters: {
            email: {
              eq: userEmail,
            },
            enable: {
              eq: true,
            },
          },
          publicationState: IPublicationState.Live,
        })
        setIsCheckingAdmin(false)
        setIsAdmin(present?.emailReceivers?.data?.length > 0)
      }
    }
    if (userInfoData?.userInfo?.email != '') {
      checkAdminEmail()
    }
  }, [userInfoData])

  useEffect(() => {
    if (
      session &&
      status === 'authenticated' &&
      session?.user.idToken &&
      session?.user.id != '' &&
      !userInfoData &&
      !loading
    ) {
      loadUserInfo({ variables: { token: session.user.idToken } })
    }
  }, [session])
  return { isAdmin, isCheckingAdmin }
}
